export class Alerts {
    static getHtml(message: string, alertClass: string, additionalClasses?: string, additionalAttributes?: string) {
        if (additionalClasses != null) {
            alertClass += " " + additionalClasses;
        }
        if (additionalAttributes == null)
            additionalAttributes = "";
        return `<div class="alert ${alertClass}" ${additionalAttributes} role="alert" aria-live="polite"><p>${message}</p></div>`;
    }

    static getSuccessHtml(message: string, additionalClasses?: string, additionalAttributes?: string) {
        return Alerts.getHtml(message, "alert-success", additionalClasses, additionalAttributes);
    }

    static getDangerHtml(message: string, additionalClasses?: string, additionalAttributes?: string) {
        return Alerts.getHtml(message, "alert-danger", additionalClasses, additionalAttributes);
    }

    static getWarningHtml(message: string, additionalClasses?: string, additionalAttributes?: string) {
        return Alerts.getHtml(message, "alert-warning", additionalClasses, additionalAttributes);
    }

    static getInfoHtml(message: string, additionalClasses?: string, additionalAttributes?: string) {
        return Alerts.getHtml(message, "alert-info", additionalClasses, additionalAttributes);
    }

    static appendErrorMessage(jqueryResult: JQuery<HTMLElement>, message: string, additionalClasses?: string, additionalAttributes?: string) {
        jqueryResult.append(Alerts.getDangerHtml(message, additionalClasses, additionalAttributes));
    }

    static setErrorMessage(jqueryResult: JQuery<HTMLElement>, message: string, additionalClasses?: string, additionalAttributes?: string) {
        jqueryResult.empty();
        jqueryResult.append(Alerts.getDangerHtml(message, additionalClasses, additionalAttributes));
    }

    static setSuccessMessage(jqueryResult: JQuery<HTMLElement>, message: string, additionalClasses?: string, additionalAttributes?: string) {
        jqueryResult.empty();
        jqueryResult.append(Alerts.getSuccessHtml(message, additionalClasses, additionalAttributes));
    }

    static prependErrorMessage(jqueryResult: JQuery<HTMLElement>, message: string, additionalClasses?: string, additionalAttributes?: string) {
        jqueryResult.prepend(Alerts.getDangerHtml(message, additionalClasses, additionalAttributes));
    }
}